
// import React, { useState, useEffect } from 'react';
// import { Box, Typography, Button, useTheme, useMediaQuery } from '@mui/material';
// import { Link, useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';

// const NewlyAdded = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const navigate = useNavigate();
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Get user data from Redux store for recording views
//   const isLoggedIn = useSelector(state => state.user.isAuthenticated);
//   const userData = useSelector(state => state.user.user);

//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         const response = await fetch('https://propertydealstalk.com/api/property/getNewestProperties?page=1&limit=4');
//         const data = await response.json();
//         if (data.status === "SUCCESS" && data.result && data.result.properties) {
//           setProperties(data.result.properties.slice(0, 4));
//         }
//       } catch (error) {
//         console.error("Error fetching properties:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProperties();
//   }, []);

//   const handleViewAllClick = (e) => {
//     e.preventDefault();
//     navigate('/newly-view');
//   };

//   // Function to record property view
//   const recordPropertyView = async (propertyId) => {
//     if (!isLoggedIn || !userData) {
//       console.log('User not logged in, skipping view recording');
//       return;
//     }

//     try {
//       // Get the user_id from userData
//       const userId = userData.id;
//       if (!userId) {
//         console.error('User ID not found in user data');
//         return;
//       }

//       console.log('Recording property view with user_id:', userId, 'property_id:', propertyId);

//       const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           property_id: propertyId
//         }),
//       });

//       const data = await response.json();
//       if (data.statusCode === 200) {
//         console.log('Property view recorded successfully:', data.result);
//       } else {
//         console.error('Failed to record property view:', data.message);
//       }
//     } catch (err) {
//       console.error('Error recording property view:', err);
//     }
//   };

//   // Handle property card click - navigate to property detail page
//   const handlePropertyClick = (propertyId) => {
//     // Record the property view
//     recordPropertyView(propertyId);
//     // Navigate to the property details page
//     navigate(`/view/${propertyId}`);
//   };

//   // ✅ Function to check if image has valid data
//   const hasValidImage = (base64) => {
//     return base64 && base64.length > 100;
//   };

//   // ✅ Function to format price with commas
//  // ✅ Function to format price with Indian numbering system (lakhs format)
// const formatPrice = (price) => {
//   if (!price || price === 0 || price === '0') return '';
  
//   const priceStr = price.toString();
//   const lastThree = priceStr.substring(priceStr.length - 3);
//   const otherNumbers = priceStr.substring(0, priceStr.length - 3);
  
//   if (otherNumbers !== '') {
//     return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
//   }
  
//   return lastThree;
// };

//   // ✅ FIXED: Function to get display price - matches TalkView.jsx logic
//   const getDisplayPrice = (property) => {
//     // Check if this is a rental property (case-insensitive comparison)
//     const category = property.category || property.commercial_catgory || '';
//     const isRental = category.toLowerCase() === 'rent';

//     if (isRental) {
//       // For rental properties, prioritize monthly_rent
//       if (property.monthly_rent && property.monthly_rent !== 0 && property.monthly_rent !== '0') {
//         return property.monthly_rent;
//       }
//     }

//     // For sale properties or if monthly_rent is not available, use asking_price
//     if (property.asking_price && property.asking_price !== 0 && property.asking_price !== '0') {
//       return property.asking_price;
//     }

//     return null; // Return null if no price is available
//   };

//   return (
//     <Box
//       component="section"
//       sx={{
//         padding: '40px 20px',
//         backgroundColor: '#fff',
//         fontFamily: 'Outfit',
//         textAlign: isMobile ? 'center' : 'left',
//       }}
//     >
//       <Box
//         className="newly-added-header"
//         sx={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'flex-end',
//           paddingBottom: '20px',
//           flexDirection: isMobile ? 'column' : 'row',
//           textAlign: isMobile ? 'center' : 'left',
//         }}
//       >
//         <Box>
//           <Typography
//             variant="h2"
//             sx={{
//               fontSize: isMobile ? '24px' : '20px',
//               margin: 0,
//               color: '#000',
//               fontWeight: 500,
//             }}
//           >
//             Newly added Properties
//           </Typography>
//           <Typography
//             sx={{
//               marginTop: '4px',
//               fontSize: '14px',
//               color: '#626262',
//               fontWeight: 400,
//             }}
//           >
//             New Listings For Checkout
//           </Typography>
//         </Box>
//         <Box sx={{ mt: isMobile ? '10px' : 0 }}>
//           <a
//             href="#"
//             className="view-all"
//             style={{
//               textDecoration: 'none',
//               fontWeight: 500,
//               color: '#626262',
//             }}
//             onClick={handleViewAllClick}
//           >
//             View All
//           </a>
//         </Box>
//       </Box>

//       <Box
//         className="properties-container"
//         sx={{
//           display: 'grid',
//           gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
//           gap: '20px',
//           overflowX: isMobile ? 'auto' : 'visible',
//           paddingBottom: '10px',
//           scrollSnapType: isMobile ? 'x mandatory' : 'none',
//           WebkitOverflowScrolling: isMobile ? 'touch' : 'auto',
//         }}
//       >
//         {properties.map((prop, index) => {
//           const hasImage = hasValidImage(prop.image);
//           const displayPrice = getDisplayPrice(prop);
//           const isRental = (prop.category || prop.commercial_catgory || '').toLowerCase() === 'rent';

//           return (
//             <Box
//               key={prop.id}
//               className="new-card"
//               sx={{
//                 borderRadius: '10px',
//                 overflow: 'hidden',
//                 transition: 'transform 0.3s ease',
//                 cursor: 'pointer',
//                 boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                 '&:hover': {
//                   transform: 'translateY(-5px)',
//                 },
//                 minWidth: isMobile ? '280px' : 'none',
//               }}
//               onClick={() => handlePropertyClick(prop.id)}
//             >
//               {/* ✅ Conditional rendering based on image availability */}
//               {hasImage ? (
//                 <Box
//                   component="img"
//                   src={`data:image/png;base64,${prop.image}`}
//                   alt={prop.property_name}
//                   sx={{
//                     width: '100%',
//                     height: '160px',
//                     objectFit: 'cover',
//                   }}
//                 />
//               ) : (
//                 <Box
//                   sx={{
//                     width: '100%',
//                     height: '160px',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     backgroundColor: '#f5f5f5',
//                     border: '1px dashed #ccc'
//                   }}
//                 >
//                   <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                     No images uploaded
//                   </Typography>
//                 </Box>
//               )}

//               <Box
//                 className="new-info"
//                 sx={{
//                   padding: '15px',
//                   textAlign: 'left',
//                 }}
//               >
//                 <Typography
//                   className="desc"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: '16px',
//                     color: '#000',
//                   }}
//                 >
//                   {prop.property_name}
//                 </Typography>
//                 <Typography
//                   component="h3"
//                   sx={{
//                     fontSize: '16px',
//                     fontWeight: 400,
//                     margin: '5px 0',
//                     color: '#626262',
//                   }}
//                 >
//                   {prop.property_type}
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontSize: '12px',
//                     color: '#626262',
//                     margin: '3px 0',
//                     fontWeight: 400,
//                   }}
//                 >
//                   {prop.area_name}, {prop.location}
//                 </Typography>

//                 {/* ✅ FIXED: Display price with proper spacing and conditional rendering */}
//                 <Typography
//                   className="price"
//                   sx={{
//                     fontSize: '14px',
//                     fontWeight: 600,
//                     color: '#2563EB',
//                     fontStyle: 'normal',
//                     mt: 1
//                   }}
//                 >
//                   {displayPrice ? (
//                     <>
//                       {prop.currency || '₹'} {formatPrice(displayPrice)}
//                       {isRental && '/month'}
//                     </>
//                   ) : (
//                     'Price on Request'
//                   )}
//                 </Typography>

//                 <Button
//                   variant="outlined"
//                   sx={{
//                     marginTop: '10px',
//                     padding: '8px 24px',
//                     color: '#2563EB',
//                     borderColor: '#2563EB',
//                     borderRadius: '5px',
//                     textTransform: 'none',
//                     fontWeight: 500,
//                     fontStyle: 'normal',
//                     width: '100%'
//                   }}
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handlePropertyClick(prop.id);
//                   }}
//                 >
//                   View Property
//                 </Button>
//               </Box>
//             </Box>
//           );
//         })}
//       </Box>
//     </Box>
//   );
// };

// export default NewlyAdded;


import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, useTheme, useMediaQuery } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const NewlyAdded = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  // Get user data from Redux store for recording views
  const isLoggedIn = useSelector(state => state.user.isAuthenticated);
  const userData = useSelector(state => state.user.user);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await fetch('https://propertydealstalk.com/api/property/getNewestProperties?page=1&limit=4');
        const data = await response.json();
        if (data.status === "SUCCESS" && data.result && data.result.properties) {
          setProperties(data.result.properties.slice(0, 4));
        }
      } catch (error) {
        console.error("Error fetching properties:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, []);

  const handleViewAllClick = (e) => {
    e.preventDefault();
    navigate('/newly-view');
  };

  // Function to record property view
  const recordPropertyView = async (propertyId) => {
    if (!isLoggedIn || !userData) {
      console.log('User not logged in, skipping view recording');
      return;
    }

    try {
      // Get the user_id from userData
      const userId = userData.id;
      if (!userId) {
        console.error('User ID not found in user data');
        return;
      }

      console.log('Recording property view with user_id:', userId, 'property_id:', propertyId);

      const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          property_id: propertyId
        }),
      });

      const data = await response.json();
      if (data.statusCode === 200) {
        console.log('Property view recorded successfully:', data.result);
      } else {
        console.error('Failed to record property view:', data.message);
      }
    } catch (err) {
      console.error('Error recording property view:', err);
    }
  };

  // Handle property card click - navigate to property detail page
  const handlePropertyClick = (propertyId) => {
    // Record the property view
    recordPropertyView(propertyId);
    // Navigate to the property details page
    navigate(`/view/${propertyId}`);
  };

  // ✅ Function to check if image has valid data
  const hasValidImage = (base64) => {
    return base64 && base64.length > 100;
  };

  // ✅ Function to format price with Indian numbering system (lakhs format)
  const formatPrice = (price) => {
    if (!price || price === 0 || price === '0') return '';
    
    const priceStr = price.toString();
    const lastThree = priceStr.substring(priceStr.length - 3);
    const otherNumbers = priceStr.substring(0, priceStr.length - 3);
    
    if (otherNumbers !== '') {
      return otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree;
    }
    
    return lastThree;
  };

  // ✅ NEW: Function to format time ago (like "2w ago")
  const getTimeAgo = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    const intervals = {
      y: 31536000,
      mo: 2592000,
      w: 604800,
      d: 86400,
      h: 3600,
      m: 60,
      s: 1
    };
    
    for (const [key, value] of Object.entries(intervals)) {
      const interval = Math.floor(diffInSeconds / value);
      if (interval >= 1) {
        return `${interval}${key} ago`;
      }
    }
    
    return 'just now';
  };

  // ✅ FIXED: Function to get display price - matches TalkView.jsx logic
  const getDisplayPrice = (property) => {
    // Check if this is a rental property (case-insensitive comparison)
    const category = property.category || property.commercial_catgory || '';
    const isRental = category.toLowerCase() === 'rent';

    if (isRental) {
      // For rental properties, prioritize monthly_rent
      if (property.monthly_rent && property.monthly_rent !== 0 && property.monthly_rent !== '0') {
        return property.monthly_rent;
      }
    }

    // For sale properties or if monthly_rent is not available, use asking_price
    if (property.asking_price && property.asking_price !== 0 && property.asking_price !== '0') {
      return property.asking_price;
    }

    return null; // Return null if no price is available
  };

  return (
    <Box
      component="section"
      sx={{
        padding: '40px 20px',
        backgroundColor: '#fff',
        fontFamily: 'Outfit',
        textAlign: isMobile ? 'center' : 'left',
      }}
    >
      <Box
        className="newly-added-header"
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          paddingBottom: '20px',
          flexDirection: isMobile ? 'column' : 'row',
          textAlign: isMobile ? 'center' : 'left',
        }}
      >
        <Box>
          <Typography
            variant="h2"
            sx={{
              fontSize: isMobile ? '24px' : '20px',
              margin: 0,
              color: '#000',
              fontWeight: 500,
            }}
          >
            Newly added Properties
          </Typography>
          <Typography
            sx={{
              marginTop: '4px',
              fontSize: '14px',
              color: '#626262',
              fontWeight: 400,
            }}
          >
            New Listings For Checkout
          </Typography>
        </Box>
        <Box sx={{ mt: isMobile ? '10px' : 0 }}>
          <a
            href="#"
            className="view-all"
            style={{
              textDecoration: 'none',
              fontWeight: 500,
              color: '#626262',
            }}
            onClick={handleViewAllClick}
          >
            View All
          </a>
        </Box>
      </Box>

      <Box
        className="properties-container"
        sx={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(4, 1fr)',
          gap: '20px',
          overflowX: isMobile ? 'auto' : 'visible',
          paddingBottom: '10px',
          scrollSnapType: isMobile ? 'x mandatory' : 'none',
          WebkitOverflowScrolling: isMobile ? 'touch' : 'auto',
        }}
      >
        {properties.map((prop, index) => {
          const hasImage = hasValidImage(prop.image);
          const displayPrice = getDisplayPrice(prop);
          const isRental = (prop.category || prop.commercial_catgory || '').toLowerCase() === 'rent';
          const timeAgo = getTimeAgo(prop.updatedAt || prop.createdAt);

          return (
            <Box
              key={prop.id}
              className="new-card"
              sx={{
                borderRadius: '10px',
                overflow: 'hidden',
                transition: 'transform 0.3s ease',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                '&:hover': {
                  transform: 'translateY(-5px)',
                },
                minWidth: isMobile ? '280px' : 'none',
              }}
              onClick={() => handlePropertyClick(prop.id)}
            >
              {/* ✅ Image Container with Time Badge */}
              <Box sx={{ position: 'relative', width: '100%', height: '160px' }}>
                {hasImage ? (
                  <Box
                    component="img"
                    src={`data:image/png;base64,${prop.image}`}
                    alt={prop.property_name}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#f5f5f5',
                      border: '1px dashed #ccc'
                    }}
                  >
                    <Typography variant="body2" color="#888" textAlign="center" px={2}>
                      No images uploaded
                    </Typography>
                  </Box>
                )}

                {/* ✅ Time Ago Badge - Positioned at bottom-right */}
                {timeAgo && (
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: '8px',
                      right: '8px',
                      bgcolor: 'rgba(0, 0, 0, 0.7)',
                      color: '#fff',
                      px: '8px',
                      py: '4px',
                      borderRadius: '4px',
                      fontSize: '11px',
                      fontWeight: 500,
                      zIndex: 2,
                    }}
                  >
                    {timeAgo}
                  </Box>
                )}
              </Box>

              <Box
                className="new-info"
                sx={{
                  padding: '15px',
                  textAlign: 'left',
                }}
              >
                <Typography
                  className="desc"
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    color: '#000',
                  }}
                >
                  {prop.property_name}
                </Typography>
                <Typography
                  component="h3"
                  sx={{
                    fontSize: '16px',
                    fontWeight: 400,
                    margin: '5px 0',
                    color: '#626262',
                  }}
                >
                  {prop.property_type}
                </Typography>
                <Typography
                  sx={{
                    fontSize: '12px',
                    color: '#626262',
                    margin: '3px 0',
                    fontWeight: 400,
                  }}
                >
                  {prop.area_name}, {prop.location}
                </Typography>

                {/* ✅ FIXED: Display price with proper spacing and conditional rendering */}
                <Typography
                  className="price"
                  sx={{
                    fontSize: '14px',
                    fontWeight: 600,
                    color: '#2563EB',
                    fontStyle: 'normal',
                    mt: 1
                  }}
                >
                  {displayPrice ? (
                    <>
                      {prop.currency || '₹'} {formatPrice(displayPrice)}
                      {isRental && '/month'}
                    </>
                  ) : (
                    'Price on Request'
                  )}
                </Typography>

                <Button
                  variant="outlined"
                  sx={{
                    marginTop: '10px',
                    padding: '8px 24px',
                    color: '#2563EB',
                    borderColor: '#2563EB',
                    borderRadius: '5px',
                    textTransform: 'none',
                    fontWeight: 500,
                    fontStyle: 'normal',
                    width: '100%'
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePropertyClick(prop.id);
                  }}
                >
                  View Property
                </Button>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default NewlyAdded;